import { render, staticRenderFns } from "./baleine-armature.vue?vue&type=template&id=1d0b99f2&scoped=true"
import script from "./baleine-armature.vue?vue&type=script&lang=js"
export * from "./baleine-armature.vue?vue&type=script&lang=js"
import style0 from "./baleine-armature.vue?vue&type=style&index=0&id=1d0b99f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0b99f2",
  null
  
)

export default component.exports